import React from 'react';
import CommonInput from 'common/components/form/inputs/Input';

const Input = props => {
  return <CommonInput label={null} invisible={true} className="mb-0" {...props} />;
};
export default Input;
